class StaffPickerController {

  displayStaff () {
    if (this.staff.length > 0) {

      if (!this.guest.staff) {
        this.guest.staff = this.staff.find(staff => !staff.disabled);
        this.guest.staff.disabled = true;
      }
    }

    return this.staff;
  }

  isDisabled () {
    return this.canDisable && this.staff.length <= 1;
  }

  updateStaff (oldStaff, newStaff) {
    if (oldStaff) {
      let staff = this.staff.find(staff => staff.id === oldStaff.id);
      if (staff) {
        delete (staff.disabled);
      }
    }

    if (newStaff.id) {
      newStaff.disabled = true;
    }
  }
}

StaffPickerController.$inject = [];

export default StaffPickerController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/availability/controllers/staffPicker.controller.js